// routes.js

import CancelReceipt from "./components/pcmc-menu/counter/cancel-receipt/cancel-receipt";
import GenerateReceipt from "./components/pcmc-menu/counter/generate-receipt/generate-receipt";
import PrintReceipt from "./components/pcmc-menu/counter/print-receipt/print-receipt";
import ReprintReceipt from "./components/pcmc-menu/counter/reprint-receipt/reprint-receipt";
import Home from "./components/pcmc-menu/home";
import PotkirdReportForBillReceipt from "./components/pcmc-menu/counter/potkird-for-bill-receipt/potkird-for-bill-receipt";
import CancelReceiptDashboard from "./components/pcmc-menu/dashboard/cancel-receipt-dashboard";
import PrefilledChallan from "./components/pcmc-menu/counter/prefilled-challan/prefilled-challan";
import CoinageChallan from "./components/pcmc-menu/counter/coinage-challan/coinage-challan";
// import Test from "./components/pcmc-menu/counter/test/test";
import PotkirdReportForPrefiled from "./components/pcmc-menu/counter/potkird-for-general-receipt/potkird-for-general-receipt";
import GetEdcTransactionStatus from "./components/pcmc-menu/counter/edc-transaction-status/edc-transaction-status";
import ViewChallan from "./components/pcmc-menu/counter/view-challan/view-challan";
import CashChallan from "./components/pcmc-menu/counter/view-challan/cash-challan";
import RevenueStampRegister from "./components/pcmc-menu/counter/revenue-stamp-register/revenue-stamp-register";
import RevenueStampReport from "./components/pcmc-menu/counter/revenue-stamp-report/revenue-stamp-report";
import ZonewiseReceiptReport from "./components/pcmc-menu/counter/zonewise-receipt-report/zonewise-receipt-report";
import ProfilePage from "./components/common/profile-page";
import AddMobileNumberToProperty from "./components/pcmc-menu/transactions/add-mobile-number-to-property";
import SearchProperty from "./components/pcmc-menu/masters/search-property";
import EdcReceipt from "./components/pcmc-menu/counter/edc-receipt/edc-receipt";
import SearchPropertyToGenReceipt from "./components/pcmc-menu/counter/generate-receipt/search-property-to-generate-receipt";

// Import other components...

const routes = [
  {
    path: "home",
    component: Home,
  },
  {
    path: "TrnGenerateReceipt",
    component: GenerateReceipt,
  },
  {
    path: "SearchPropertyToGenReceipt",
    component: SearchPropertyToGenReceipt,
  },
  {
    path: "PrintReceipt",
    component: PrintReceipt,
  },
  {
    path: "ReceiptReprint",
    component: ReprintReceipt,
  },
  {
    path: "CancelReceipt",
    component: CancelReceipt,
  },
  {
    path: "PotkirdReportForBillReceipt",
    component: PotkirdReportForBillReceipt,
  },
  {
    path: "PotkirdReportForPrefiled",
    component: PotkirdReportForPrefiled,
  },
  {
    path: "CancelReceiptDashboard",
    component: CancelReceiptDashboard,
  },
  {
    path: "GeneratePrefilledReceipt",
    component: PrefilledChallan,
  },
  {
    path: "CreateCoinageChallan",
    component: CoinageChallan,
  },
  {
    path: "GetEDCTxnStatus",
    component: GetEdcTransactionStatus,
  },
  {
    path: "ViewChallan",
    component: ViewChallan,
  },
  {
    path: "CashChallan",
    component: CashChallan,
  },
  {
    path: "RevenueStampRegister",
    component: RevenueStampRegister,
  },
  {
    path: "RevenueStampReport",
    component: RevenueStampReport,
  },
  {
    path: "ZonewiseReceiptReport",
    component: ZonewiseReceiptReport,
  },
  // {
  //   path: "Test",
  //   component: Test,
  // },
  {
    path: "profile",
    component: ProfilePage,
  },
  {
    path: "AddMobileNumberToProperty",
    component: AddMobileNumberToProperty,
  },
  {
    path: "SearchProperty",
    component: SearchProperty,
  },
  {
    path: "edc-receipt",
    component: EdcReceipt,
  },
  // Add other routes here
];

export default routes;
